import { Component, inject, model, signal } from '@angular/core';
import { AccessService } from '../../core/services/access.service';
import { ProfileService } from '../../profile/services/profile.service';
import { UserFormComponent } from "../user-form/user-form.component";
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';
import { UserInterface } from '../interfaces/user.interface';

@Component({
  selector: 'app-user-delete',
  standalone: true,
  imports: [UserFormComponent],
  templateUrl: './user-delete.component.html',
  styleUrl: './user-delete.component.css'
})
export class UserDeleteComponent {
  private route = inject(ActivatedRoute)
  private service = inject(UserService)

  protected profile = inject(ProfileService).profile
  protected access = inject(AccessService).access

  protected id!: string | null;

  protected value = model<User | undefined>(undefined)

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Usario Eliminado')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      this.service.delete(id).subscribe(data => {
        this.value.update(value => (value = new User(data as UserInterface)));
      });
    }
  }
}
